import type { MergeDevRoutes } from '@tempo-io/sir-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getSirMergeDevApi = ({
  prefixUrl = '',
  client,
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<MergeDevRoutes>('/api/sir/v1/merge-dev/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
